module.exports = __webpack_public_path__ + "ba1d8888e82437958b024abee5637383.pdf";